import React from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ProductCard from '../../components/ProductCard/ProductCard';
import useFaceBook from '../../hooks/useFaceBook';
import useMixpanel from '../../hooks/useMixpanel';
import { useSelector } from 'react-redux';

export default function StageContent() {
  const history = useHistory();

  const { sendFb } = useFaceBook();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { trackP1Event } = useMixpanel();
  const nextPage = useSelector((state) => state.appRoute.nextPage);

  const handleClick = (value, id) => {
    sendFb("AddToCart", {})
    queryParams.set('stage', value);
    queryParams.set('stage-id', id);
    trackP1Event('onboarding_stage', {
      stage: value
    })
    history.push({
      pathname: nextPage,
      search: `?${queryParams.toString()}`
    });
  }
  return (
    <>
      <ProductCard
        title={'Just starting'}
        img={'/img/WEBP_selling stage/Just-started.webp'}
        onClick={() => handleClick("Just starting", 0)}
      />
      <ProductCard
        title={'Already selling'}
        img={'/img/WEBP_selling stage/Already selling.webp'}
        onClick={() => handleClick('Already selling', 1)}
      />
    </>
  )
}
